<template>
  <div class="menuBox" :style="{'min-width':menuShow?'240px':'64px'}">
    <el-scrollbar wrap-style="overflow-x:hidden;" style="height: calc(100% - 61px);"> <!--11的顶部以及50的底部-->
      <el-menu
        :default-active="activeMenu"
        :collapse="!menuShow"
        class="el-menu-vertical border-0"
        :background-color="'transparent'"
        text-color="black"
        :unique-opened="true"
        :active-text-color="'#000'"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" :class="menuShow?'':'customMenuShow'"/>
      </el-menu>
    </el-scrollbar>
    <div class="menuBox-bottom">
        <div class="bottom-info">
            <!-- <div class="bottom-img">
              <img src="~@/assets/logoSmile.png" alt="">
            </div> -->
            <span style="letter-spacing: 4px;">宝就业平台管理系统</span>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import path from 'path'
import '@/assets/css/base.css'


export default {
  components: {
    SidebarItem,
  },
  props: {
    menuShow: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    routes() {
      // return this.$router.options.routes
      return this.$store.state.route.currentRoutes.children
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    // 计算需要默认展开的父级菜单
    defaultOpeneds() {
      const route = this.$route
      const currentPath = route.path
      const openeds = []
      
      // 获取一级路由路径（currentRoutes.path）
      const currentRoutes = this.$store.state.route.currentRoutes
      const topLevelPath = currentRoutes && currentRoutes.path ? currentRoutes.path : ''
      
      if (!topLevelPath || !this.routes || this.routes.length === 0) {
        return openeds
      }
      
      // 递归查找需要展开的父级菜单
      const findParentPaths = (routes, targetPath, basePath = '') => {
        if (!routes || !Array.isArray(routes)) return
        
        for (const routeItem of routes) {
          if (routeItem.hidden) continue
          
          // 使用与 SidebarItem 相同的路径解析方式
          const resolvedPath = path.resolve(topLevelPath, basePath, routeItem.path)
          
          // 如果当前路径包含这个路由路径，说明这是父级
          if (targetPath.startsWith(resolvedPath) && targetPath !== resolvedPath) {
            // 检查这个路由是否有子项且不是只有一个子项（有子项才会显示为 submenu）
            if (routeItem.children && routeItem.children.length > 0) {
              const visibleChildren = routeItem.children.filter(child => !child.hidden)
              // 只有当有多个可见子项时，才需要展开
              if (visibleChildren.length > 1 || (visibleChildren.length === 1 && visibleChildren[0].children && visibleChildren[0].children.length > 0)) {
                openeds.push(resolvedPath)
                // 继续查找子级
                findParentPaths(routeItem.children, targetPath, resolvedPath)
              }
            }
          }
        }
      }
      
      findParentPaths(this.routes, currentPath)
      
      return openeds
    },
    showLogo() {
      // return this.$store.state.settings.sidebarLogo
      return false
    },
  }
}
</script>
<style scoped lang="scss">
.customMenuShow{
  /deep/.el-submenu__title{
    span{
      display: none;
    }
  }
}
.menuBox{
   background-image: url("~@/assets/menuBg.png");
  //background-color:#2A354F;
  // border-top-left-radius: 8px;
  // border-bottom-left-radius: 8px;
  // padding-top: 20px;
  background-size: cover;
  .logo{
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    img{
      width:64px;
      height:64px;
    }
  }
  a{
    text-decoration: none;
  }
  /deep/.el-submenu__title{
  // background: #1E2249 !important;
  color: #fff !important;
  transition: border-color .3s,background-color 0s,color .3s;
}
}
.ljsb{
  color: #fff;
  background: #2D65BF;
  border-radius: 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  padding: 7px 36px;
  margin: 34px 0;
  cursor: pointer;
}
.line{
  width: 150px;
  border-bottom: 1px solid #849DB1;
  margin-top: 24px;
}
/deep/.el-submenu .el-menu-item{
  height: 48px;
  line-height: 48px;
  min-width: 164px;

}
/deep/.el-menu-item.is-active{
  background: linear-gradient(90deg, rgba(30, 111, 255, 0.2) 0%, rgba(30, 111, 255, 0.05) 100%)!important;
  border-radius: 4px;

}

.el-menu-item,/deep/.el-submenu__title{
  transition: border-color .3s,background-color 0s,color .3s;
}
/deep/.el-menu-item{
  background: transparent !important;
  color: #fff !important;

}
/deep/.el-submenu__title:hover{
    background-color: transparent!important;
  }
.menuBox-bottom{
  margin-top: 11;
  height: 50px;
  border-top: 1px solid #3A4466;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 15px 0;
  .bottom-img{
    width: 24px;
    height: 24px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .bottom-info{
     color:var(--vt-c-white);
     font-size: var(--font-size);
     font-weight: var(--font-weight-normal);
     display: flex;
     align-items: center;
     justify-content: center;
     height: 24px;
  }
}
</style>
